import React, { useState, useEffect } from 'react'
import styles from './NPATab.module.scss'
import DocTable from '../../components/DocTable/DocTable'
import SearchBar from '../../components/SearchBar/SearchBar'
import { getNPAList, downloadNPA } from 'service/KomurConnectionService'
import { filterDocs } from '../../utils'

export default function NPATab({ onPreview }) {
  const [docs,   setDocs]   = useState(null)
  const [search, setSearch] = useState('')

  useEffect(() => {
    getNPAList()
      .then(r => setDocs(r.data))
      .catch(() => setDocs([]))
  }, [])

  const handleDownload = (_docType, id, fileName) => {
    downloadNPA(id).then(r => {
      const a = document.createElement('a')
      a.href = r.data.file_url
      a.download = fileName || 'document'
      a.click()
    }).catch(() => {})
  }

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>Нормативно-правовые акты</h3>
      <SearchBar value={search} onChange={setSearch} placeholder="Поиск НПА…" />
      <DocTable
        docs={filterDocs(docs, search)}
        docType="npa"
        onDownload={handleDownload}
        onPreview={onPreview}
      />
    </div>
  )
}
